import {inject, Inject, Injectable, Renderer2, DOCUMENT} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExternalResourcesService {
  private document = inject(DOCUMENT)

  loadScript(renderer: Renderer2, settings: any): HTMLScriptElement {
    const script = renderer.createElement('script');
    if (!settings.isNotExterneal) {
      script.type = 'text/javascript';
      script.src = settings.src;
    }
    if (settings.isAsync) {
      script.async = '';
    }
    if (settings.id) {
      script.id = settings.id;
    }
    if (settings.text) {
      script.text = settings.text;
    }
    if (settings.config) {
      renderer.setAttribute(script, 'config', settings.config);
    }
    renderer.appendChild(this.document.body, script);
    return script;
  }
}
